<template>
	<div class="sale-notice">
		<!-- 导航 -->
		<!-- <van-nav-bar
		  title="系统公告"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<headerTemplate title="系统公告"></headerTemplate>

		<!-- 通知公告 -->
		<div class="public-notice">
			<div class="public-nav">
				<span class="nav-item">ID</span>
				<span class="nav-item">标题</span>
				<span class="nav-item">发布时间</span>
				<span class="nav-item">操作</span>
			</div>
			<div class="public-content" v-for="(item, i) in AnnounceList" :key="i">
				<span class="content-item">{{item.amt_id}}</span>
				<span class="content-item">{{item.amt_title}}</span>
				<span class="content-item">{{item.amt_time}}</span>
				<span class="content-item content-item-oprate" @click="goNoticeInfo(item.amt_id)">详情</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { getAnnouncement } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleNotice',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 公告列表
				AnnounceList: []
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			},
			// 跳转到noticeInfo页
			goNoticeInfo(InfoId) {
				this.$router.push({
					name: 'NoticeInfo',
					params: {
						InfoId: InfoId
					}
				})
			}
		},
		created() {
			getAnnouncement().then(res => {
				this.AnnounceList = res.result
			}).catch(error => {
				// this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.sale-notice {
		font-size: 14px !important;

		.public-notice {
			background-color: #fff;
			box-shadow: 0 0 5px #EEEEEE;
			margin: 10px;
			border-radius: 10px;
			padding: 10px;
		}

		.public-nav {
			display: flex;
			margin-bottom: 10px;
			border-bottom: 1px solid #EDEDED;
			padding-bottom: 10px;

			.nav-item {
				flex: 1;
				text-align: center;
			}
		}

		.public-content {
			display: flex;

			.content-item {
				flex: 1;
				text-align: center;
			}

			.content-item-oprate {
				color: #1989FA;
			}
		}

		.public-content:not(:last-child) {
			margin-bottom: 10px;
		}
	}
</style>